<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import { TabsIndicator } from 'reka-ui';
  import type { TabsIndicatorProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<
    TabsIndicatorProps & { class?: HTMLAttributes['class']; variant: 'glass' | 'underline' }
  >();

  const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <TabsIndicator
    data-slot="tabs-indicator"
    :class="
      cn(
        'z-3 absolute left-0 bottom-0 w-[var(--reka-tabs-indicator-size)] translate-x-[var(--reka-tabs-indicator-position)] transition-[width,translate,transform] duration-300',
        variant === 'underline' ? 'h-0.5 px-1' : 'h-full py-1',
        props.class,
      )
    "
    v-bind="delegatedProps"
  >
    <slot>
      <div
        :class="
          cn(
            'h-full w-full',
            variant === 'glass'
              ? 'rounded-sm border-1 border-transparent dark:border-input dark:bg-transparent bg-background shadow-sm'
              : 'bg-foreground',
          )
        "
      />
    </slot>
  </TabsIndicator>
</template>
